import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    beforeEnter: islogged,
    component: () => import('@/layouts/login/Index.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import( /* webpackChunkName: "login" */ '@/views/login/Login.vue'),
      },
    ]
  },
  {
    path: '/admin',
    beforeEnter: auth,
    component: () => import('@/layouts/admin/Index.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import( /* webpackChunkName: "admin" */ '@/views/admin/Index.vue'),
      },
      {
        path: '/manager/users',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/users/Index.vue'),
        children: [
          {
            path: '',
            name: 'List Users',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/users/Users.vue'),
          },
          {
            path: '/manager/users/new',
            name: 'New User',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/users/New.vue'),
          },
          {
            path: '/manager/users/:idUser',
            name: 'Edit User',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/users/Edit.vue'),
          },
        ]
      },
      {
        path: '/manager/configs',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/configs/Index.vue'),
        children: [
          {
            path: '',
            name: 'List Gates',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/configs/Configs.vue'),
          }
        ]
      }, {
        path: '/manager/history-tags',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/historyTag/Index.vue'),
        children: [
          {
            path: '',
            name: 'List Tags',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/historyTag/HistoryTags.vue'),
          }]
      },
      {
        path: '/manager/persons',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/persons/Index.vue'),
        children: [
          {
            path: '',
            name: 'List Persons',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/persons/Persons.vue'),
          },
          {
            path: ':idPerson',
            name: 'Edit Persons',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/persons/Edit.vue'),
          }
        ]
      },
      {
        path: '/manager/clocks',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/register/Index.vue'),
        children: [
          {
            path: '',
            name: 'List Register',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/register/Register.vue'),
          }
        ]
      },
      {
        path: '/manager/syncs',
        component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/syncs/Index.vue'),
        children: [
          {
            path: '',
            name: 'Sincronizacoes',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/syncs/Sync.vue'),
          },
          {
            path: '/manager/syncs/processamento-retroativo',
            name: 'ProcessamentoRetroativo',
            component: () => import( /* webpackChunkName: "institution" */ '@/views/admin/syncs/ProcessamentoRetroativo.vue'),
          }
        ]
      },
      {
        path: '/manager/audit-logs',
        component: () => import( /* webpackChunkName: "audit-logs" */ '@/views/admin/auditLogs/Index.vue'),
        children: [
          {
            path: '',
            name: 'AuditLogs',
            component: () => import( /* webpackChunkName: "audit-logs" */ '@/views/admin/auditLogs/AuditLogs.vue'),
          }
        ]
      },
    ]
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import( /* webpackChunkName: "admin" */ '@/views/Error.vue'),
  },
  {
    path: '*',
    redirect: '/error'
  },
]

function auth(to, from, next) {
  if (localStorage.getItem('token') != undefined) {
    validate(next, 'auth');
  } else {
    next("/");
  }
}
function islogged(to, from, next) {
  if (localStorage.getItem('token') != undefined) {
    validate(next, 'islogged');
  } else {
    next();
  }
}

async function validate(next, operation) {
  await axios.post('/validate', {}, {
    headers: {
      'x-access-token': localStorage.getItem('token')
    }
  }).then(res => {
    if (res.data.permission) {
      // console.log(res.data)
      store.dispatch('addUser', res.data);
      if (operation === "islogged") {
        if (res.data.master) {
          next('/admin');
        } else {
          next('/admin');
        }
      } else {
        next();
      }
    }
  }).catch(() => {
    // console.log(err.response);
    if (operation === "auth") {
      next("/");
    }
    if (operation === "islogged") {
      localStorage.removeItem('token');
      next("/");
    }
  });
}


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
